/**
 * base-core.entry.js — esbuild --bundle entrypoint for the base.html core glue.
 *
 * Side-effect imports the Turbo/bridge/offline glue scripts that base.html
 * previously loaded as eight separate deferred <script> tags; esbuild emits a
 * single IIFE. Output: base-core.bundle.min.js (+ source map).
 *
 * Membership rule: every module here is already self-wrapping — each file is an
 * IIFE or a loadOnce() call with no top-level declarations — so it leaks no
 * implicit globals and publishes what it exports via an explicit `window.X =`.
 * Bundling is therefore semantically identical to the separate tags. Scripts
 * that rely on classic-script scoping (a bare top-level `function foo()`
 * becoming window.foo) are deliberately NOT here; bundling those silently
 * unbinds the global and breaks the call site at click time.
 *
 * Order is the source of truth and matches the previous tag order exactly:
 * the edit-modal/navigation glue, then the offline layer, then the native
 * bridge. chippie-bridge before bridge-commands
 * (commands extend the facade), and the whole bundle before
 * controllers.bundle.min.js (bridge controllers call register() at module
 * eval).
 *
 * <!-- Sourced by: templates/base.html -->
 */
import "./turbo-edit-modal.js";
import "./accepted-quote-confirm.js";
import "./turbo-navigation.js";
import "./powersync-entities.js";
import "./page-check.js";
import "./offline-indicator.js";
import "./chippie-bridge.js";
import "./bridge-commands.js";
